import momentTZ from 'moment-timezone';

/**
 * Convert time based on format passed down
 * @param {
 *   Object {
 *     datetime: string,
 *     zone: string,
 *     oldFormat: string,
 *     newFormat: string
 *   }
 * } props - properties for moment.js
 * @returns
 */
function timeZoneConvert({ datetime, zone, oldFormat, newFormat }) {
  let format = newFormat;
  if (!newFormat) {
    format = oldFormat;
  }

  const datetimeUtc = momentTZ(datetime, oldFormat).utc().format();

  if (!momentTZ(datetimeUtc).isValid()) {
    return datetime;
  }

  return momentTZ.tz(datetimeUtc, zone).format(format);
}

/**
 * Get time zone string that is consumed by moment.js function
 * @param {string} country
 * @returns {string}
 */
function getAreaTimeZone(country) {
  let zone = '';

  switch (country) {
    case 'ID':
      zone = 'Asia/Jakarta';
      break;
    case 'MY':
      zone = 'Asia/Kuala_Lumpur';
      break;
    case 'SG':
      zone = 'Asia/Singapore';
      break;
    default:
      zone = 'Asia/Jakarta';
      break;
  }

  // return 'Africa/Cairo'
  return zone;
}

/**
 * Convert time using moment.js
 * @param {string} datetime
 * @param {string=} country
 * @param {string=} newformat
 * @param {string=} oldformat
 * @returns {string}
 */
function convertTimeZone(datetime, country, newformat, oldformat) {
  let newFormat = 'DD MMM YY, HH:mm';
  let oldFormat = 'YYYY-MM-DD HH:mm:ss';

  if (newformat) {
    newFormat = newformat;
  }

  if (oldFormat) {
    oldFormat = oldformat;
  }

  const zone = getAreaTimeZone(country);
  const lastMessageDate = timeZoneConvert({
    datetime,
    zone,
    oldFormat,
    newFormat,
  });

  return momentTZ(lastMessageDate).isValid() ? lastMessageDate : datetime;
}

export default convertTimeZone;
